// extracted by mini-css-extract-plugin
export var active = "_le-2";
export var recordingDot = "_le-1";
export var recordingIndicator = "_le-0";